import { useCurrentClient } from '@mysten/dapp-kit-react'
import { useQuery } from '@tanstack/react-query'

import { PositionInfo } from '@/shared/kai/hooks/useUserPositions'
import { CetusRedemptionUtil } from '@kunalabs-io/kai'

export const cetusRedemptionInfoQueryKey = (positionId: string) =>
  ['cetus-redemption-info', positionId] as const

export const useCetusRedemptionInfo = (positionInfo: PositionInfo, isCetusAffected: boolean) => {
  const client = useCurrentClient()

  const cetusRedemptionInfoRes = useQuery({
    queryKey: cetusRedemptionInfoQueryKey(positionInfo.positionId),
    enabled: Boolean(positionInfo.lastPosition && isCetusAffected),
    queryFn: async () => {
      if (!positionInfo.lastPosition) {
        throw new Error('Invariant violation: positionInfo.lastPosition is undefined')
      }
      if (!positionInfo.lastPosition.isCetus()) {
        return {
          cetusRedemptionAmount: undefined,
        }
      }

      const cetusRedemptionAmount = await CetusRedemptionUtil.getCetusRedemptionAmount(
        client,
        positionInfo.lastPosition
      )

      return {
        cetusRedemptionAmount: cetusRedemptionAmount,
      }
    },
  })

  return {
    isLoading: cetusRedemptionInfoRes.isLoading,
    cetusRedemptionAmount: cetusRedemptionInfoRes?.data?.cetusRedemptionAmount,
  }
}
